import { createSlice } from "@reduxjs/toolkit";

import { addNewTagsData, deleteTags, fetchTagsList, updateGates } from "../thunks/tagsThunks";

import type { Tags } from "../../utils/types/tags";


interface TagsListState {
  tagList: Tags[];
  loading: boolean;
  error: string | null;
}
const initialState: TagsListState = {
  tagList: [],
  loading: false,
  error: null,
};

export const tagListSlice = createSlice({
  name: "gatesList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTagsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTagsList.fulfilled, (state, action) => {
        state.tagList = action.payload;
        state.loading = false;
      })
      .addCase(fetchTagsList.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(updateGates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGates.fulfilled, (state, action) => {
        state.loading = false;
        state.tagList = state.tagList.map((gates:Tags) => {
          if (gates?.tag_id === action?.payload?.data?.tag_id) {
            return { ...gates, ...action?.payload?.data };
          }
          return gates;
        });
      })
      .addCase(updateGates.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deleteTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tagList = state.tagList.filter(
          (gates) => gates.tag_id !== action.payload.id
        );
      })
      .addCase(deleteTags.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewTagsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewTagsData.fulfilled, (state, action) => {
        state.loading = false;
        state.tagList=[action.payload,...state.tagList]
      })
      .addCase(addNewTagsData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
  },
});

export default tagListSlice.reducer;
